<template>
	<StandardModal
		open
		small
		:title="group.title"
		:confirmText="$t('groupsettings_people_remove_button')"
		:confirmProps="{ danger: true, loading }"
		ref="deactivate"
		@cancel="$emit('cancel')"
		@confirm="removeFromGroup"
	>
		<div class="remove-from-group">
			<TrashCanIcon halo class="logo" />

			<div class="help">
				{{
					$t('people_removefromgroup_confirm_warning_desc', {
						UserName: person.fullname,
					})
				}}
			</div>
		</div>
	</StandardModal>
</template>

<script>
import { StandardModal } from '@/components/common'
import { TrashCanIcon } from '@/icons'
import { del } from '../common'

export default {
	name: 'RemoveFromGroupModal',
	props: ['group', 'person'],
	components: { StandardModal, TrashCanIcon },

	data() {
		return {
			loading: false,
		}
	},

	emits: ['success', 'cancel'],

	methods: {
		async removeFromGroup() {
			this.loading = true
			try {
				await del(
					`/organization/groups/${this.group.id}/memberships/${this.person.id}`
				)
				this.$alert.success(
					this.$t('admin_people_confirmation_removed_from_group_label')
				)

				this.$emit('success')
			} catch (e) {
				this.loading = false
				this.$alert.error(this.$t('admin_groups_unable_remove_person_error'))
			}

			this.$emit('cancel')
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.remove-from-group {
	display: flex;
	flex-direction: column;
	align-items: center;

	.logo {
		font-size: 50px;
		color: var(--red-200);
		margin-top: 24px;
	}

	.help {
		font-family: Avenir;
		font-weight: 500;
		font-size: 18px;
		color: var(--neutral-800);
		width: 320px;
		text-align: center;
		margin-top: 20px;
		margin-bottom: 20px;
	}
}
</style>
